
export const TestBanner = {
  loader: () => import(
  /* webpackChunkName: 'TestBanner' */
    './components/test-banner/index.jsx'
  )
};

export const SimpleTopAd = {
  loader: () => import(
    /* webpackChunkName: 'SimpleTopAd' */
    './components/tes-top-ad/layouts/Simple.jsx'
  )
};

export const MediumCtaTopAd = {
  loader: () => import(
    /* webpackChunkName: 'MediumCtaTopAd' */
    './components/tes-top-ad/layouts/MediumCta.jsx'
  )
};

export const LargeCtaTopAd = {
  loader: () => import(
    /* webpackChunkName: 'LargeCtaTopAd' */
    './components/tes-top-ad/layouts/LargeCta.jsx'
  )
};

export const LargeTopAd = {
  loader: () => import(
    /* webpackChunkName: 'LargeTopAd' */
    './components/tes-top-ad/layouts/Large.jsx'
  )
};

export const XLFullWidthCtaTopAd = {
  loader: () => import(
    /* webpackChunkName: 'XLFullWidthCtaTopAd' */
    './components/tes-top-ad/layouts/XLFullWidthCta.jsx'
  )
};

export const XLFullWidthTopAd = {
  loader: () => import(
    /* webpackChunkName: 'XLFullWidthTopAd' */
    './components/tes-top-ad/layouts/XLFullWidth.jsx'
  )
};

export const DiscountTopAd = {
  loader: () => import(
    /* webpackChunkName: 'DiscountTopAd' */
    './components/tes-top-ad/layouts/Discount.jsx'
  )
};
